var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.016 1.334c-4.414 0-8.004 3.588-8.004 8s3.59 8 8.004 8 8.004-3.588 8.004-8-3.59-8-8.004-8zm0 17.333c-5.148 0-9.338-4.187-9.338-9.334C6.678 4.187 10.868 0 16.016 0c5.148 0 9.338 4.187 9.338 9.333 0 5.147-4.19 9.334-9.338 9.334z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 32,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.334h32V32H0V17.334z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.62 32H1.41a.667.667 0 01-.622-.425l-.15-.384c-.015-.027-3.357-8.283 5.42-13.756a.668.668 0 01.917.212.664.664 0 01-.212.918c-7.55 4.71-5.065 11.66-4.898 12.102h28.31c.32-.868 2.461-7.506-4.896-12.102a.666.666 0 11.706-1.13c8.488 5.301 5.552 13.401 5.422 13.742l-.169.411a.667.667 0 01-.616.412z",
    fill: "#000"
  }))));
}
SvgAccount.displayName = 'Account';
export default SvgAccount;